module.exports = __webpack_public_path__ + "img/10.0159e15b.png";